import React from 'react'

export default props => (
  <svg viewBox="0 0 18 16" {...props}>
    <path d="M13.5 0H4.5C2.015 0 0 2.015 0 4.5V11.5C0 13.985 2.015 16 4.5 16H13.5C15.985 16 18 13.985 18 11.5V4.5C18 2.015 15.985 0 13.5 0ZM16.5 11.5C16.5 13.157 15.157 14.5 13.5 14.5H4.5C2.843 14.5 1.5 13.157 1.5 11.5V4.5C1.5 2.843 2.843 1.5 4.5 1.5H13.5C15.157 1.5 16.5 2.843 16.5 4.5V11.5Z" />
    <path d="M4.5 5.5H13.5V6.5H4.5V5.5Z" />
    <path d="M4.5 8H10.5V9H4.5V8Z" />
    <path d="M4.5 10.5H12V11.5H4.5V10.5Z" />
    <path d="M12 7.5L15 9.5L12 11.5Z" />
  </svg>
)
